// extracted by mini-css-extract-plugin
export default {"video_player":"_2hCrP","videoPlayer":"_2hCrP","video_container":"MEdo4","videoContainer":"MEdo4"};